/**
 * Entry point for development and production PWA builds.
 */
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import App from './App';
import React from 'react';

/**
 * EXTENSIONS AND MODES
 * =================
 * pluginImports.js is dynamically generated from extension and mode
 * configuration at build time.
 *
 * pluginImports.js imports all of the modes and extensions and adds them
 * to the window for processing.
 */
import { modes as defaultModes, extensions as defaultExtensions } from './pluginImports';
import loadDynamicConfig from './loadDynamicConfig';
import { publicUrl } from './utils/publicUrl';
import { initLifecycleRecovery } from './utils/lifecycleRecovery';
export { history } from './utils/history';
export { preserveQueryParameters, preserveQueryStrings } from './utils/preserveQueryParameters';

/**
 * LIFECYCLE RECOVERY
 * ==================
 * Inicializa el sistema de recuperación de pestañas para Chromium.
 * Esto maneja el caso cuando una pestaña está en background y el navegador
 * la congela (freeze) para ahorrar recursos. Al volver, el visor puede
 * quedar en un estado inconsistente sin este sistema.
 *
 * Configurable via window.config.lifecycleRecovery:
 * - hiddenThresholdMs: tiempo en ms para forzar recarga (default: 60000)
 * - enabled: habilitar/deshabilitar (default: true)
 */
initLifecycleRecovery({
  hiddenThresholdMs: window.config?.lifecycleRecovery?.hiddenThresholdMs || 60000,
  enabled: window.config?.lifecycleRecovery?.enabled !== false,
  enableLogging: true,
});

loadDynamicConfig(window.config).then(config_json => {
  // Reset Dynamic config if defined
  if (config_json !== null) {
    window.config = config_json;
  }
  window.config.routerBasename ||= publicUrl;

  /**
   * Combine our appConfiguration with installed extensions and modes.
   * In the future appConfiguration may contain modes added at runtime.
   *  */
  const appProps = {
    config: window ? window.config : {},
    defaultExtensions,
    defaultModes,
  };

  const container = document.getElementById('root');

  const root = createRoot(container);
  root.render(React.createElement(App, appProps));
});
